var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"gamanza-widget-page",style:(_vm.pageStyle)},[(!_vm.gamanzaReady)?_c('div',{staticClass:"gamanza-widget-page__loading"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-2x"})]):_c('div',{staticClass:"gamification_widget",attrs:{"id":_vm.widgetId,"data-type":_vm.type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }